import * as yup from 'yup';

const mobilePaymentSchema = yup
    .object({
        referenceCode: yup
            .string()
            .min(6, 'Referencia debe tener al menos 6 dígitos')
            .required('Referencia requerida'),
        bankId: yup
            .number()
            .required('Debe seleccionar un banco')
            .min(1, 'Debe seleccionar un banco'),
        date: yup
            .string()
            .matches(/^\d{2}\/\d{2}\/\d{4}$/, 'Formato DD/MM/YYYY inválido')
            .required('Fecha requerida'),
        phone: yup
            .string()
            .matches(
                /^04(12|14|24|16|26|22)\d{7}$/,
                'Formato 04XXXXXXXXX inválido'
            )
            .required('Teléfono requerido'),
        nin: yup.string().min(3, 'CI inválida').required('CI requerida'),
    })
    .required();

const casheaSchema = yup
    .string()
    .min(3, 'Mínimo 3 caracteres')
    .required('Número de compra requerido');

const zelleSchema = yup
    .string()
    .min(3, 'Mínimo 3 caracteres')
    .required('Nombre del titular requerido');

export { mobilePaymentSchema, casheaSchema, zelleSchema };
